/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import {useTranslation} from 'react-i18next'
import {PaginationTable} from '../../../../components/PaginationTable/PaginationTable'
import {StyledCard} from '../../../../components/StyledCard'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useMaterialProducts} from '../../../../services/useMaterialProducts'
import {ButtonGroups} from './ButtonGroups'
import {RowData} from './RowData'
import {RowFilter} from './RowFilter'

type Props = {
  className: string
}

export const TableMaterial: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()

  const {
    firstPage,
    isError,
    isLoading,
    lastPage,
    materialProducts,
    numberUrls,
    handlePageChange,
    handleReloadData: onReloadTable,
  } = useMaterialProducts()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({colSpan: 8, onReloadTable})

  return (
    <StyledCard>
      <ButtonGroups />

      <TableUI.TableWrapper style={{marginBottom: 0}}>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Material Group')}</th>
              <th>{t('Material Number')}</th>
              <th>{t('Company Code')}</th>
              <th>{t('Plant')}</th>
              <th>{t('Material Description')}</th>
              <th>{t('Distribution Channel')}</th>
              <th>{t('Plant Desc')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {isLoading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : materialProducts?.length === 0 ? (
              <RowEmptyData />
            ) : (
              <RowData items={materialProducts} />
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      {numberUrls.length > 0 && (
        <PaginationTable
          links={numberUrls}
          firstPageUrl={firstPage}
          lastPageUrl={lastPage}
          onPageChange={(page) => handlePageChange(page)}
        />
      )}
    </StyledCard>
  )
}
